/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../../utils/constants';

const IDS = {
  HOME_PAPERLESSBILLING_DETAILS: 'settings.communications.home.paperlessbilling.details',
  HOME_SECTION_TEXT: 'settings.communications.home.section.text',
  PAPERLESS_LOANCARD_BUTTON_ARIALABEL: 'settings.communications.paperless.loanCard.button.ariaLabel',
  PAPERLESS_LOANCARD_HEADING: 'settings.communications.paperless.loanCard.loannumber',
};

const enMessages = {
  [IDS.HOME_PAPERLESSBILLING_DETAILS]: '{num, plural, one {# Loan} other {# Loans}}',
  [IDS.HOME_SECTION_TEXT]: 'Manage how we deliver important loan-related notifications to you.',
  [IDS.PAPERLESS_LOANCARD_BUTTON_ARIALABEL]: 'paperless billing notifications: loan {loanNumber}',
  [IDS.PAPERLESS_LOANCARD_HEADING]: 'Loan ({loanNumber})',
};

const enMurabahaMessages = {
  ...enMessages,
  [IDS.HOME_PAPERLESSBILLING_DETAILS]: '{num, plural, one {# Account} other {# Accounts}}',
  [IDS.HOME_SECTION_TEXT]: 'Manage how we deliver important account-related notifications to you.',
  [IDS.PAPERLESS_LOANCARD_BUTTON_ARIALABEL]: 'paperless billing notifications: loan {loanNumber}',
  [IDS.PAPERLESS_LOANCARD_HEADING]: 'Account ({loanNumber})',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
